import styled from 'styled-components';
import type { ImageValue } from '@elfsight/configurator-contracts';
import { Icon } from '../../common';

interface IconsItemProps {
  data: {
    icon: ImageValue;
    hint: string;
  };
  className?: string;
}

export function IconsItem({ data, className = '' }: IconsItemProps) {
  const { icon, hint } = data;

  return (
    <Component className={className}>
      <Icon icon={icon} size={28} style={{ flexShrink: 0 }} alt="" />
      <Name>{hint}</Name>
    </Component>
  );
}

const Component = styled.div`
  display: flex;
  align-items: center;
`;
const Name = styled.div`
  opacity: 0.65;
  font-size: 14px;
  line-height: 1.14;
  color: #111111;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 6px;
`;
